module.exports = __webpack_public_path__ + "static/media/Group 13.655d0ea3.png";